import { MasterSheetList, MasterSheetEdit } from './views';

export default {
  edit: MasterSheetEdit,
  list: MasterSheetList,
  name: 'job-master-sheet',
  label: 'Production List',
  to: '/job-master-sheet',
};
